import { Component } from '@angular/core';
import { UserService } from 'src/app/services/user.service';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { TranslateService } from '@ngx-translate/core';
import { HttpAlertService } from 'src/app/services/http-alert.service';
import { Title } from '@angular/platform-browser';

@Component({
    selector: 'change-password-details',
    templateUrl: './changePassword.component.html',
    styleUrls: ['./changePassword.component.scss']
})
export class ChangePasswordComponent {

    changePasswordForm: FormGroup;

    constructor(private userService: UserService, private formBuilder: FormBuilder, private translate: TranslateService, private alertService: HttpAlertService,private title: Title) {
        this.initForm();
    }

    ngOnInit(): void {
        this.translate.get('title_change_password').subscribe({
            next: (title) => {
              this.title.setTitle(title);
            }
          });
    }

    public initForm(): void {
        this.changePasswordForm = this.formBuilder.group({
            old_password: ['', [Validators.required]],
            new_password_one: ['', [Validators.required]],
            new_password_two: ['', [Validators.required]],
        });
    }

    public onSubmit(): void {
        if (this.changePasswordForm.get('new_password_one').value == this.changePasswordForm.get('new_password_two').value) {
            this.userService.changePassword(this.changePasswordForm.value).subscribe(
                result => {
                    if (result.data == 'error') {
                        this.translate.get(result.message).subscribe(t => { this.alertService.error(t) });
                    } else {
                        this.translate.get(result.message).subscribe(t => { this.alertService.success(t) });
                        this.initForm();
                    }
                }
            );
        } else {
            this.translate.get('passwords_not_same_error').subscribe(t => { this.alertService.error(t) });
        }
    }

}